<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<p class="EP">‘Photography takes an instant out of time, altering life by holding it still.’</p>
<p class="EPC"><span class="ePub-SC">DOROTHEA LANGE</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?171772c2